export default class License {
  id: number
  key: string
  provider_id: number
  valid: Date
  device_id: number
  price: number

  constructor(values: License) {
    Object.assign(this, values)
    this.valid = new Date(values.valid)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Licenses/Model.ts